import React, { useState } from 'react';
import { Tabs, Tab, AppBar } from '@material-ui/core';

function SimpleTabs(props: any) {
  const [value, setValue] = useState(props?.value);

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
    props?.onChange(newValue)
  };

  return (
    <div>
      <AppBar position="static">
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
          {
            props?.data?.map((item: any, index: any) => {
              return <Tab label={item} value={index} key={index}/>
            })
          }

        </Tabs>
      </AppBar>
    </div>
  );
}

export default SimpleTabs;



// WEBPACK FOOTER //
// ./src/shared/components/TabView/index.tsx